import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faXmark,
  faMinus,
  faExclamation,
} from '@fortawesome/free-solid-svg-icons';

import { blue } from '~theme';

const grey = '#cdd1de';
const lightGrey = '#eef0f4';
const checkMarkGrey = '#9e9e9e';
const red = '#ba3a34';

const Bead = ({ state, i }) => {
  if (state === 'DONE') {
    return <DoneBead />;
  }
  if (state === 'CANCELED') {
    return <CanceledBead />;
  }
  if (state === 'ACTIVE') {
    return <ActiveBead />;
  }
  if (state === 'CANCELED_UPCOMING') {
    return <MinusBead />;
  }
  if (state === 'UPCOMING') {
    return <NumberBead>{i}</NumberBead>;
  }
  if (state === 'PENDING') {
    return <ExclamationBead />;
  }

  console.error(`No match for state ${state} in Bead`);

  return <ActiveBead />;
};

const ActiveBead = () => (
  <Circle color={blue}>
    <StyledIcon icon={faCheck} />
  </Circle>
);

const NumberBead = ({ children }) => <Circle>{children}</Circle>;

const DoneBead = () => (
  <Circle color={lightGrey}>
    <StyledIcon icon={faCheck} color={checkMarkGrey} />
  </Circle>
);

const CanceledBead = () => (
  <Circle color={red}>
    <StyledIcon icon={faXmark} />
  </Circle>
);

const MinusBead = () => (
  <Circle color={lightGrey}>
    <StyledIcon icon={faMinus} color={checkMarkGrey} />
  </Circle>
);

const ExclamationBead = () => (
  <Circle color={blue}>
    <StyledIcon icon={faExclamation} />
  </Circle>
);

const Circle = styled.div`
  width: 24px;
  height: 24px;
  background: ${props => props.color ?? grey};
  clip-path: circle();

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 12px;
  font-weight: 600;
`;

const StyledIcon = styled(FontAwesomeIcon)`
  color: ${props => props.color ?? 'white'};
  width: 14px;
`;

export default Bead;
